// Notifications navigateur (pur, défensif — sûr si l'API est absente/refusée).

/** Demande la permission une fois si elle est encore « default ». No-op sinon. */
export function requestNotifyPermission(): void {
  try {
    if ("Notification" in window && Notification.permission === "default") {
      void Notification.requestPermission();
    }
  } catch {
    /* API indisponible */
  }
}

/** Affiche une notification si la permission est accordée. `onClick` ramène l'app au premier plan. */
export function notify(title: string, body: string, onClick?: () => void): void {
  try {
    if (!("Notification" in window) || Notification.permission !== "granted") return;
    const n = new Notification(title, { body, tag: "agency-os" });
    n.onclick = () => {
      try {
        window.focus();
      } catch {
        /* ignore */
      }
      onClick?.();
      n.close();
    };
  } catch {
    /* échec silencieux */
  }
}
